<script setup>
// Telefones além do principal no "Editar contato": rótulo + número, um por
// linha. A mesclagem de contatos também acrescenta aqui (backend).
import { useI18n } from 'vue-i18n';
import NextButton from 'dashboard/components-next/button/Button.vue';

const telefones = defineModel({ type: Array, default: () => [] });
const { t } = useI18n();

const adicionar = () => {
  telefones.value = [...telefones.value, { rotulo: '', numero: '' }];
};

const remover = indice => {
  telefones.value = telefones.value.filter((_, i) => i !== indice);
};

const alterar = (indice, campo, valor) => {
  telefones.value = telefones.value.map((item, i) =>
    i === indice ? { ...item, [campo]: valor } : item
  );
};
</script>

<template>
  <div class="w-full mb-4">
    <label>{{ t('CONTACT_FORM.FORM.TELEFONES_ADICIONAIS.LABEL') }}</label>
    <div
      v-for="(telefone, indice) in telefones"
      :key="indice"
      class="flex items-center gap-2 mb-2"
    >
      <input
        :value="telefone.rotulo"
        type="text"
        class="!mb-0 !w-2/5"
        :placeholder="t('CONTACT_PANEL.TELEFONE_CONTATO_N', { n: indice + 1 })"
        @input="alterar(indice, 'rotulo', $event.target.value)"
      />
      <input
        :value="telefone.numero"
        type="tel"
        class="!mb-0 flex-1"
        :placeholder="t('CONTACT_FORM.FORM.TELEFONES_ADICIONAIS.NUMERO')"
        @input="alterar(indice, 'numero', $event.target.value)"
      />
      <NextButton
        ghost
        sm
        ruby
        icon="i-lucide-trash-2"
        :aria-label="t('CONTACT_FORM.FORM.TELEFONES_ADICIONAIS.REMOVER')"
        @click.prevent="remover(indice)"
      />
    </div>
    <NextButton
      ghost
      sm
      icon="i-lucide-plus"
      :label="t('CONTACT_FORM.FORM.TELEFONES_ADICIONAIS.ADICIONAR')"
      @click.prevent="adicionar"
    />
  </div>
</template>
